import * as React from 'react';

type CampaignData = {
  discount?: string;
  campaign?: string;
  certificate?: string;
  content?: string;
};

const CampaignContext = React.createContext<CampaignData>({});

export const CampaignProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, setState] = React.useState<CampaignData>({});

  React.useEffect(() => {
    if (typeof window === 'undefined') return; // SSR guard
    const params = new URLSearchParams(window.location.search);

    const discount = params.get('discount') || undefined;
    const campaign = params.get('utm_campaign') || undefined;
    const certificate = params.get('certificate') || undefined;
    const content = params.get('utm_content') || undefined;

    setState({
      discount,
      campaign,
      certificate,
      content,
    });
  }, []);

  return (
    <CampaignContext.Provider value={state}>
      {children}
    </CampaignContext.Provider>
  );
};

export const useCampaign = () => React.useContext(CampaignContext);
